import React from "react";
import BasePaginatedDropdown from "./BasePaginatedDropdown";
import { type DropdownWithoutOptionsProps } from "../models";

interface Props extends DropdownWithoutOptionsProps<server.dto.Airline> {
  displayFriendyCodeInSelectedValue: boolean;
}

const AirlinePaginatedDropdown = (props: Props) => {
  const fetchAirlines = async (search: string, page: number) => {
    const res = await window.CoreApi.Airline.List({
      excludeKeys: props.excludeKeys ?? [],
      keyword: search,
      page,
      perPage: 10
    });

    return res;
  };

  return <BasePaginatedDropdown
    excludeKeys={props.excludeKeys}

    fetchOptions={fetchAirlines}
    renderSelectedValue={a => props.displayFriendyCodeInSelectedValue ? `${a.name} (${a.friendlyCode})` : a.name}
    getLabel={a => a.name}
    getValue={a => a.airlineId}
    getSubLabel={a => a.friendlyCode}
    config={props.config}
    value={props.value}
    onChange={props.onChange}
  />;
};

export default AirlinePaginatedDropdown;